﻿const ignoreUpdateItemTypes = [
	'mpp_ProcessPlan',
	're_Requirement',
	're_Requirement_Document',
	'sm_Task',
	'Project'
];

export default ignoreUpdateItemTypes;
